import { Locale, type LocalizedString } from "../Locale.js";

export const productAddedPathMap = {
	[Locale.cs]: "produkt-pridan" as const,
} satisfies LocalizedString;
